
export function isValidVietnamPhone(phoneNumber: string): boolean {
  if (!phoneNumber) return false;

  const normalized = phoneNumber.trim();

  const vnPhoneRegex = /^(0|\+84)(3|5|7|8|9)[0-9]{8}$/;

  return vnPhoneRegex.test(normalized);
}
